export const SET_USERINFO = 'SET_USERINFO'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_ISMENUSHOW = 'SET_ISMENUSHOW'
export const SET_MENULIST = 'SET_MENULIST'
export const SET_MENUSELECT = 'SET_MENUSELECT'
